module.exports = __webpack_public_path__ + "static/img/透明 印花机.fe8e37d2.png";